import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-zi3ilj-0"
})(["display:flex;flex-direction:column;", " width:100%;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(10, 'column');
}, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6, 'column');
}));